<template>
  <div class="row-red-nav">
    <div class="main-width">
      <ul id="red-nav-navbar" class="list-basic-settings">
        <li><a href="home.html" class="row-red-nav-a">首页</a></li>
        <li><a href="purchase.html" class="row-red-nav-a">物资招标</a></li>
        <li><a href="logisticses.html" class="row-red-nav-a">工程招标</a></li>
        <li><a href="engineering.html" class="row-red-nav-a">服务招标</a></li>
        <!--<li><a href="deal.html" class="row-red-nav-a">询比价</a></li>-->
        <!-- <li><a href="deal.html" class="row-red-nav-a">竞买竞卖</a></li>
        <li><a href="notice.html" class="row-red-nav-a">公告信息</a></li> -->
        <li><a href="contact.html" class="row-red-nav-a">联系我们</a></li>
        <li><a href="https://www.yonyouyc.com/yuncai" class="row-red-nav-a">返回官网</a></li>
      </ul>
    </div>
  </div>
</template>
<script>
  export default{
    name: 'grednav',
    props: {
      type: ''
    }
  }
</script>
<style>
  /*row-red-nav*/
  .row-red-nav {
    height: 40px;
    background-color: #eb5559;
  }

  #red-nav-navbar > li {
    width: 15%;
    height: 40px;
    text-align: center;
    line-height: 40px;
  }

  #red-nav-navbar > li > a {
    display: block;
    width: 100%;
    height: 100%;
  }

  #red-nav-navbar > li:hover {
    background-color: #cb4347;
    cursor: pointer;
  }

  .row-red-nav-a, .row-red-nav-a:hover, .row-red-nav-a:visited {
    font-size: 16px;
    color: #ffffff;
    text-decoration: none;
  }

  .li-active {
    background-color: #cb4347;
  }
</style>



// WEBPACK FOOTER //
// G-rednav.vue?1f4bf89e